/**
 * Returns a Promise that resolves after the next frame paint
 * @returns {Promise<void>}
 */
export const nextTick = (): Promise<void> =>
  new Promise((res) => queueMicrotask(() => setTimeout(res, 0)));
